import React, { memo, ReactElement } from 'react';

import { BlockComponentSelectorProps } from './BlockComponentSelectorProps';

function BlockComponentSelector({ content, componentSelector, contentSizes }: BlockComponentSelectorProps): ReactElement {
    const BlockComponent = componentSelector(content);
    if (BlockComponent) {
        return <BlockComponent {...content} contentSizes={contentSizes} />;
    } else {
        return <></>;
    }
}

export default memo(BlockComponentSelector);
